module.exports = __webpack_public_path__ + "collectTrue.28b553fe.png";